
export const all_routes = { //Instructor Modules
    instructorDashboard: '/admin/admin-dashboard',
    instructorProfile: '/admin/admin-profile',
    instructorAssignment: '/admin/admin-assignment',
    instructorQuiz: '/admin/admin-quiz',
    instructorQuizQuestions: '/admin/admin-quiz/admin-quiz-questions',
    instructorQuizResult: '/admin/admin-quiz-results',
    privacyPolicy: "/privacy-policy",
    termsConditions: "/terms-conditions",
    refundPolicy: "/refund-policy",
    contactUs: "/contact-us",
    about_us: "/about-us",
    mobileLogin:"/mobile/login",

    // auth
    login:"/",
    adminLogin:"/admin/login",
    forgotpassword:"/admin/forgot-password",
    otp:"/admin/forgot-otp",
    setpassowrd:"/admin/set-password",
    changePassowrd:"/admin/change-password",

    // student

    studentDashboard: '/student/student-dashboard',
    studentProfile: '/student/student-profile',
    studentQuiz: '/student/student-quiz',
    studentQuizResult: '/student/exam-result',
    studentQuizQuestion: '/student/student-quiz-questions',
    scheduleExam: '/admin/schedule-exam',
    adminStudentsList: '/admin/students-list',
    commingSoon:'/coming-soon'

 
};
